export enum TransactionServiceType {
    DINE_IN = 'dine_in',
    TAKE_OUT = 'take_out',

    // Possible future service types:
    // PICKUP = 'pickup',
    // DELIVERY = 'delivery',
    // CURBSIDE = 'curbside',     
    // DRIVE_THRU = 'drive_thru',  
}